import { BadgeType } from '@kc-console/context';

/**
 * BadgeType과 name에 따라 Badge color를 반환
 * - PHASE → black
 * - STATUS + name 'New' → purple
 * - STATUS + name 'Update' → blue
 */
export const getBadgeColor = (type: BadgeType, name: string) => {
  if (type === BadgeType.PHASE) {
    return 'black';
  }
  if (type === BadgeType.STATUS) {
    const normalized = name.toLowerCase();
    if (normalized === 'new') {
      return 'purple';
    }
    if (normalized === 'update') {
      return 'blue';
    }
  }
  return 'gray';
};

export const getBadgeVariant = (type: BadgeType) => {
  switch (type) {
    case BadgeType.PHASE:
      return 'filled';
    case BadgeType.STATUS:
      return 'outline';
    default:
      return 'filled';
  }
};
